/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, FormControlLabel, Checkbox, Tooltip} from '@material-ui/core';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';

export default function ChatDisposition(props)
{
    const [chatDisposition, setChatDisposition] = useState(false);

    /** Set disposition to value being passed through props */
    useEffect(() => {
        setChatDisposition(props.value);
    },[props.value])

    // Handle hold checkbox change
    const handleChatDisposition = () => {
        setChatDisposition(!chatDisposition);
        props.onChange(!chatDisposition);
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={chatDisposition}
                        onChange={handleChatDisposition}
                        name="chatDisposition"
                        color="primary"
                        />
                    }
                    label="Disposition"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Give permission for chat dispositions">
                        <DoneOutlineIcon color="primary"/>
                    </Tooltip>
                </Grid>

            </Grid>
            
        </div>
    );
}

